import { jsx as n, jsxs as i, Fragment as h } from "react/jsx-runtime";
import { fpds as u } from "@fcamna/shared-component-foundations";
import { c as p } from "./index-65016bfa.mjs";
import { useState as I, Children as a, cloneElement as N } from "react";
import { styled as m } from "styled-components";
import { u as k } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Button as V } from "./button.js";
import { Icon as j } from "./icon.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "@fcamna/shared-icons";
const A = m.div`
  &.ShowMoreLessWrapper {
    ${(e) => `
  display: ${e.$alignment === "inline" ? e.theme.components.showMoreLess.ShowMoreLessWrapper.display.inLineAlignment : e.theme.components.showMoreLess.ShowMoreLessWrapper.display.default};
  height: ${e.$alignment === "inline" ? e.theme.components.showMoreLess.ShowMoreLessWrapper.height.inLineAlignment : e.theme.components.showMoreLess.ShowMoreLessWrapper.height.default};
  padding: ${e.$alignment === "left" ? e.theme.components.showMoreLess.ShowMoreLessWrapper.padding.leftAlignment : e.$alignment === "inline" ? e.theme.components.showMoreLess.ShowMoreLessWrapper.padding.inLineAlignment : e.theme.components.showMoreLess.ShowMoreLessWrapper.padding.default};
  box-sizing: ${e.theme.components.showMoreLess.ShowMoreLessWrapper.boxSizing};
  width: ${e.theme.components.showMoreLess.ShowMoreLessWrapper.width};
  ${e.$alignment === "center" && `margin:${e.theme.components.showMoreLess.ShowMoreLessWrapper.margin}`};
  ${e.$alignment === "center" && `justify-content: ${e.theme.components.showMoreLess.ShowMoreLessWrapper.justifyContent}`};
  &:hover {
    .show-more-icon {
      color: ${e.theme.components.showMoreLess.ShowMoreLessWrapper.hover.showMoreIcon.color};
      cursor:${e.theme.components.showMoreLess.ShowMoreLessWrapper.hover.showMoreIcon.cursor};
    }
    span {
      color: ${e.theme.components.showMoreLess.ShowMoreLessWrapper.hover.span.color};
      cursor: ${e.theme.components.showMoreLess.ShowMoreLessWrapper.hover.span.cursor};
      border-bottom: ${e.theme.components.showMoreLess.ShowMoreLessWrapper.hover.span.borderBottom};
    }
  }

  &:focus-visible {
      && > div {
          outline: ${e.theme.components.showMoreLess.ShowMoreLessWrapper.focusVisible.div.outline};
          border-radius: ${e.theme.components.showMoreLess.ShowMoreLessWrapper.focusVisible.div.borderRadius};
          padding: ${e.theme.components.showMoreLess.ShowMoreLessWrapper.focusVisible.div.padding};
          outline-offset:${e.theme.components.showMoreLess.ShowMoreLessWrapper.focusVisible.div.outlineOffset};
      }
      outline: ${e.theme.components.showMoreLess.ShowMoreLessWrapper.focusVisible.outline};
    }
    `}
  }
`, B = m.div`
  > p {
    display: unset;
    margin: unset;
  }
  ${(e) => e.$alignment === "inline" && `display : ${e.theme.components.showMoreLess.BodyContentContainer.display}`};
`, z = m(V)`
  &.ShowMoreLessContainer {
    ${(e) => `
  padding: ${e.theme.components.showMoreLess.ShowMoreLessContainer.padding} !important;
  background-color: ${e.theme.components.showMoreLess.ShowMoreLessContainer.backgroundColor} !important;
  
   ${e.disabled ? `color:${e.theme.components.showMoreLess.ShowMoreLessContainer.color.disabled}!important` : `color:${e.theme.components.showMoreLess.ShowMoreLessContainer.color.default}`} ;
  &:hover {
    background-color: ${e.theme.components.showMoreLess.ShowMoreLessContainer.hover.backgroundColor} !important;
    text-decoration: ${e.disabled ? e.theme.components.showMoreLess.ShowMoreLessContainer.hover.textDecoration.disabled : e.theme.components.showMoreLess.ShowMoreLessContainer.hover.textDecoration.default};
    color: ${e.disabled ? e.theme.components.showMoreLess.ShowMoreLessContainer.hover.color.disabled : e.theme.components.showMoreLess.ShowMoreLessContainer.hover.color.default} ;
    cursor : ${e.disabled ? e.theme.components.showMoreLess.ShowMoreLessContainer.hover.cursor.disabled : e.theme.components.showMoreLess.ShowMoreLessContainer.hover.cursor.default};
    && > {
      color: ${e.disabled ? e.theme.components.showMoreLess.ShowMoreLessContainer.hover.color.disabled : e.theme.components.showMoreLess.ShowMoreLessContainer.hover.color.default};
    }
  }

  & svg {
    ${e.disabled && `
      color: ${e.theme.components.showMoreLess.ShowMoreLessContainer.svg.disableColor}!important ;
      cursor : ${e.theme.components.showMoreLess.ShowMoreLessContainer.svg.cursor} !important;
      `}
  }
  `}
  }
`, T = ({
  alignment: e = "left",
  className: c,
  children: r,
  previewContent: t,
  showMoreLessText: l = { showMore: "Show More", showLess: "Show Less" },
  disabled: S
}) => {
  const $ = k({ label: "Show More Less" }), [s, g] = I(!1), f = () => {
    g(!s);
  }, b = () => /* @__PURE__ */ n(
    j,
    {
      name: s ? "caretUpFilled" : "caretDownFilled",
      "aria-label": "caret-up",
      height: "20px",
      width: "20px",
      color: u.semantic.color.icon.primary,
      className: "show-more-icon"
    }
  ), w = () => /* @__PURE__ */ i(h, { children: [
    /* @__PURE__ */ n("span", { style: { padding: `0 ${u.semantic.space["2x"]}` } }),
    /* @__PURE__ */ n(
      A,
      {
        onClick: f,
        className: p(["ShowMoreLessWrapper", c]),
        $alignment: e,
        tabIndex: 0,
        "aria-label": "show-more-less",
        children: /* @__PURE__ */ n(
          z,
          {
            size: "medium",
            variant: "text",
            rightIcon: b(),
            disabled: S,
            className: "ShowMoreLessContainer",
            children: s ? l.showLess : l.showMore
          }
        )
      }
    )
  ] }), C = () => a.map(s ? r : t, (o, y) => {
    var M, L;
    const x = s ? a.count(r) : a.count(t);
    if (y === x - 1) {
      const d = /* @__PURE__ */ i(h, { children: [
        typeof o == "string" || !((M = o == null ? void 0 : o.props) != null && M.children) ? o : o.props.children,
        w()
      ] });
      return typeof o == "string" || !((L = o == null ? void 0 : o.props) != null && L.children) ? d : N(o, {
        children: d
      });
    } else
      return o;
  }), v = () => /* @__PURE__ */ i(h, { children: [
    s ? r : t,
    w()
  ] });
  return /* @__PURE__ */ n(
    B,
    {
      $alignment: e,
      className: p(["ShowMoreLess", c]),
      ...$,
      children: e === "inline" ? C() : v()
    }
  );
};
export {
  T as ShowMoreLess
};
